/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { CheckCircle } from '@mui/icons-material';
import { Box, Typography, CircularProgress } from '@mui/material';

export const ConfirmApproveRequestModal = (props) => {
  const [approveSuccessOpen, setApproveSuccessOpen] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const handleEditRequestAction = async () => {
    setRequestLoading(true);
    const action = 'approved';
    const url = apiUrl(`/eis/empeditrequest/action/${action}`);
    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          editReqId: props.editRequest._id,
          empid: props.editRequest.empid,
        }),
      });

      if (!response.ok) {
        console.error(`Error updating edit request:`, response.statusText);
        return null;
      }

      //const data = await response.json();
      setApproveSuccessOpen(true);
      await props.fetchEditRequestData();
    } catch (err) {
      console.error(`Error fetching`, err);
    }
    props.setRequestModal(false);
    setRequestLoading(false);
  };

  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={async () => {
          await handleEditRequestAction();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircle sx={{ fontSize: 30 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: '#20c997' }}>
              Approve Edit Request
            </Typography>
          </Box>
        }
        desc={
          requestLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                mt: 7,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
                Are you sure you want to approve this request?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This action cannot be undone and the employee's data will be
                updated.
              </Typography>
            </Box>
          )
        }
        primaryBtnName={'Approve'}
        secondaryBtnName={requestLoading ? null : 'Cancel'}
        primaryStyle={{
          bgcolor: '#20c997',
          border: '1px solid #20c997',
          '&:hover': {
            bgcolor: '#17b48c !important',
            borderColor: '#17b48c',
          },
          ...(requestLoading && { visibility: 'hidden' }),
        }}
        secondaryStyle={{
          ...(requestLoading && { visibility: 'hidden' }),
        }}
      />
      <SuccessModal
        open={approveSuccessOpen}
        onClose={() => {
          setApproveSuccessOpen(false);
          props.onSuccess();
        }}
        close={() => {
          setApproveSuccessOpen(false);
          props.onSuccess();
        }}
        desc={'You have successfully updated an employee.'}
      />
    </>
  );
};
